import { useSnapshot } from 'valtio';

import * as userStore from '@cartwhl/common/stores/userStore';
import {
  formatOrgCreditsForDisplay,
  getOrgAvailableCredits,
  isOrgCreditsWorkspace,
} from '@cartwhl/common/utils/organizationWorkspace';
import Avatar from '@cartwhl/ui/atoms/Avatar';
import Text from '@cartwhl/ui/base/Text';
import UserMenu from '@cartwhl/ui/organisms/UserMenu';

export default function UserMenuWithCredits() {
  const { loading: userLoading, userInfo, organizationInfo } = useSnapshot(
    userStore.state,
  );

  const orgCreditsWorkspace = isOrgCreditsWorkspace(organizationInfo);
  const orgAvailableCredits = getOrgAvailableCredits(organizationInfo);

  const creditsAmount = formatOrgCreditsForDisplay(orgAvailableCredits).trim();
  const spinsAmount = String(userInfo.spinsAvailable ?? '').trim();

  const displayName =
    `${userInfo.firstName ?? ''} ${userInfo.lastName ?? ''}`.trim() ||
    userInfo.email;

  return (
    <UserMenu
      trigger={
        <button
          type="button"
          className="outline-hidden hover:bg-gray-15 data-[state=open]:bg-gray-15 hover:dark:bg-gray-75 data-[state=open]:dark:bg-gray-90 flex shrink-0 cursor-pointer items-center gap-2 rounded-lg border-0 bg-transparent px-2 py-1 transition-colors sm:gap-2 sm:px-2.5 sm:py-1.5"
          aria-label="Account menu"
        >
          {!userLoading ? (
            <span className="flex min-w-0 flex-col items-end gap-0.5 pr-0.5">
              <Text
                as="span"
                variant="studio/body/medium/sm"
                className="text-primary flex min-w-0 flex-row flex-wrap items-baseline justify-end gap-x-1 font-medium"
              >
                {orgCreditsWorkspace ? (
                  <>
                    <span className="tabular-nums">{creditsAmount}</span>
                    <span>credits</span>
                  </>
                ) : (
                  <>
                    <span className="tabular-nums">{spinsAmount}</span>
                    <span>Spins</span>
                  </>
                )}
              </Text>
              <Text
                as="span"
                variant="studio/body/sm"
                className="text-tertiary max-w-40 truncate"
              >
                {displayName}
              </Text>
            </span>
          ) : null}
          <span className="flex h-9 w-9 shrink-0 items-center justify-center">
            <Avatar userInfo={userInfo} />
          </span>
        </button>
      }
    />
  );
}
